// US locale: ar
export default {
  "login.title": "MedConcil",
  "login.subtitle": "دعم القرار السريري",
  "login.welcome": "مرحباً",
  "login.signInMessage": "Sign in to access your MedConcil workspace",
  "login.continueWithGoogle": "Continue with Google",
  "login.terms": "By signing in, you agree to our Terms of Service and Privacy Policy",
  "login.feature1.title": "Multi-Model Consensus",
  "login.feature1.desc": "Query GPT and Op simultaneously",
  "login.feature2.title": "Enterprise PII Protection",
  "login.feature2.desc": "Automatic redaction of sensitive data before LLM processing",
  "login.feature3.title": "Team Collaboration",
  "login.feature3.desc": "Full audit logging and cost governance for your organization",
  "login.signInDesc": "سجّل الدخول للوصول إلى المجلس السريري",
  "login.signInGoogle": "تسجيل الدخول عبر Google",
  "login.signingIn": "جارٍ تسجيل الدخول...",
  "login.signInEmail": "تسجيل الدخول بالبريد الإلكتروني",
  "login.password": "كلمة المرور",
  "login.register": "إنشاء حساب",
  "login.noAccount": "ليس لديك حساب؟",
  "login.createAccount": "أنشئ حساباً",
  "login.hasAccount": "لديك حساب بالفعل؟",
  "login.signIn": "تسجيل الدخول",
  "login.or": "أو",
  "login.checkEmail": "Check your email for the confirmation link",
  "login.error": "Sign in failed",
  "login.oauthNotConfigured": "This sign-in method is not available in this deployment.",
  "login.forgotPassword": "نسيت كلمة المرور؟",
  "login.rememberMe": "تذكرني",
  "login.emailVerified": "Email verified. Please sign in.",
  "login.resetSent": "Password reset link sent to your email",
  "login.enterEmailFirst": "Enter your email first",
  "login.gdpr": "GDPR Compliant",
  "login.pii": "PII Redacted",
  "login.footer": "Clinical Decision Support - Not a Replacement for Physician Judgment",
  "legal.termsNoticeSignin": "By signing in, you agree to our",
  "legal.termsNoticeSignup": "By creating an account, you agree to our",
  "legal.privacyPolicy": "Privacy Policy",
  "legal.termsOfUse": "Terms of Use",
  "legal.cookiePolicy": "Cookie Policy",
  "legal.and": "and",
  "legal.redirecting": "Redirecting to the legal page…",
  "nav.voice": "Voice",
  "nav.query": "Query",
  "nav.history": "History",
  "nav.admin": "Admin",
  "nav.adminSection": "Admin",
  "nav.clinicalSupport": "Clinical Decision Support",
  "nav.account": "Account",
  "nav.settings": "Settings",
  "nav.signOut": "Sign out",
  "nav.activeCouncil": "Active Council",
  "nav.plan": "plan",
  "voice.pageTitle": "Voice Recording",
  "voice.readyTitle": "Record an appointment",
  "voice.readyDesc": "Press to start recording a conversation with the patient",
  "voice.consent": "Make sure the patient has given consent to recording",
  "voice.recordingLabel": "Recording in progress",
  "voice.transcribing": "Recognizing speech...",
  "voice.reviewLabel": "Conversation transcript â edit if needed",
  "voice.send": "Send to Consilium",
  "voice.reRecord": "Record again",
  "voice.noKey": "Groq API key not set",
  "voice.noKeyTitle": "Groq API key not set",
  "voice.noKeyDesc": "Add the key in the Admin section for speech recognition to work",
  "voice.goToAdmin": "Go to Admin",
  "voice.permDenied": "Microphone access denied. Check browser permissions.",
  "voice.noSupport": "Browser does not support audio recording",
  "admin.groqKeyLabel": "Groq API Key (for speech recognition)",
  "admin.groqKeyDesc": "Key for speech recognition via Groq Whisper. Stored locally in browser.",
  "admin.groqPersonalLabel": "Personal key (this browser only)",
  "admin.groqServerLabel": "Default key (for all users)",
  "admin.groqServerActive": "Active for all users",
  "admin.groqServerKeySet": "Server key is configured",
  "admin.groqServerKeyNotSet": "No server key set",
  "admin.groqServerSaved": "Server key saved",
  "admin.groqServerError": "Failed to save server key",
  "admin.groqKeySaved": "Groq API key saved",
  "admin.groqKeyCleared": "Groq API key cleared",
  "admin.saved": "Saved",
  "admin.save": "Save",
  "query.voiceCardTitle": "Record an appointment",
  "query.voiceCardDesc": "Record a conversation with the patient and send it to the Consilium",
  "query.chairmanStreaming": "Chairman is composing the response...",
  "query.title": "Ask the Consilium",
  "query.placeholder": "Ask anything... The consilium will deliberate and provide a consensus answer.",
  "query.piiNotice": "PII is automatically redacted",
  "query.submit": "اسأل المجلس",
  "query.textSize": "حجم النص",
  "query.textSizeDecrease": "تصغير النص",
  "query.textSizeIncrease": "تكبير النص",
  "query.loading": "Consilium is deliberating...",
  "query.consiliumWorking": "Consilium is deliberating...",
  "query.remaining": "remaining",
  "query.almostDone": "Almost done...",
  "query.attachmentWaitNote": "Attached documents take longer — each advisor reads the full file. Please stay on this page.",
  "query.stagePii": "PII screening",
  "query.stageModels": "Models analyzing",
  "query.stageChairman": "Chairman synthesizing",
  "query.stageSaving": "Finalizing",
  "query.success": "Consilium has responded!",
  "query.stage1": "Individual Responses",
  "query.stage3": "Consilium Synthesis",
  "query.chairmanNote": "The Consilium reviewed all responses and compiled this final answer",
  "query.patientMessage": "Patient Message",
  "query.readyToSend": "Ready to review",
  "query.patientMessageNote": "Review and send to the patient. Written in plain language.",
  "query.physicianReview": "Physician Review Summary",
  "query.internalOnly": "Internal",
  "query.tokens": "Tokens",
  "query.yourCost": "Your Cost",
  "query.piiRedacted": "PII entities redacted",
  "query.models": "models",
  "query.emptyTitle": "Ready to consult the Consilium",
  "query.emptyDesc": "Your query will be sent to multiple AI models. They'll analyze and the consilium will synthesize the best answer.",
  "query.addImage": "Photo",
  "query.addFile": "File",
  "query.fileTooLarge": "File too large (max 25MB)",
  "query.tooManyFiles": "Too many files (max {max}).",
  "query.attachmentsTooLarge": "Total attachments too large (max 50MB).",
  "query.unsupportedFile": "Unsupported file type",
  "query.imageTooLarge": "Image too large (max 10MB)",
  "query.timeout": "Query timed out. Please try again.",
  "query.followupTitle": "Follow-up questions to the council",
  "query.followupPlaceholder": "Ask a follow-up question...",
  "query.followupError": "Error sending question",
  "query.followupLimitExceeded": "Follow-up limit reached for this case.",
  "query.followupLimitReached": "You've used all follow-up questions for this case. Start a new case to continue.",
  "query.followupAttachmentsExhausted": "Follow-up attachment limit reached for this case.",
  "query.followupStartNewCase": "Start a new case",
  "query.copied": "Copied",
  "query.copy": "Copy",
  "query.downloadPdf": "Download PDF",
  "query.pdfDownloaded": "PDF downloaded",
  "query.pdfError": "Error downloading PDF",
  "query.pdfNoQuery": "No data to download â run a query first",
  "history.title": "Query History",
  "history.queries": "queries",
  "history.exportCsv": "Export CSV",
  "history.searchPlaceholder": "Search queries...",
  "history.startDate": "Start date",
  "history.endDate": "End date",
  "history.start": "Start",
  "history.end": "End",
  "history.clear": "Clear",
  "history.noQueries": "No queries yet",
  "history.timestamp": "Timestamp",
  "history.queryCol": "Query",
  "history.modelsCol": "Models",
  "history.costCol": "Your Cost",
  "history.piiCol": "PII",
  "history.view": "View",
  "history.queryDetails": "تفاصيل الحالة",
  "history.caseSummary": "ملخص الحالة",
  "history.synthesis": "الملخص",
  "history.exported": "History exported!",
  "admin.title": "Admin Panel",
  "admin.dashboard": "Dashboard",
  "admin.auditLog": "Audit Log",
  "admin.team": "Team",
  "admin.settings": "Settings",
  "admin.accessDenied": "Access Denied",
  "admin.noPermission": "You don't have permission to access this page.",
  "dashboard.queriesThisMonth": "Queries this month",
  "dashboard.totalSpend": "Total spend",
  "dashboard.activeUsers": "Active users",
  "dashboard.avgCostPerQuery": "Avg cost/query",
  "dashboard.queriesPerDay": "Queries per Day",
  "dashboard.spendByModel": "Spend by Model",
  "dashboard.topUsers": "Top Users",
  "dashboard.user": "User",
  "dashboard.queries": "Queries",
  "dashboard.spend": "Spend",
  "dashboard.noData": "No data yet",
  "team.title": "Team Members",
  "team.members": "members",
  "team.inviteMembers": "Invite Members",
  "team.inviteTitle": "Invite Team Members",
  "team.inviteDesc": "Add new members to your organization",
  "team.emailAddresses": "Email Addresses",
  "team.emailPlaceholder": "john@example.com, jane@example.com",
  "team.role": "Role",
  "team.member": "Member",
  "team.adminRole": "Admin",
  "team.auditor": "Auditor",
  "team.owner": "Owner",
  "team.cancel": "Cancel",
  "team.sendInvites": "Send Invites",
  "team.joined": "Joined",
  "team.actions": "Actions",
  "team.pendingInvites": "Pending Invites",
  "settings.councilConfig": "إعدادات المجلس",
  "settings.councilConfigDesc": "اضبط أخصائيي الذكاء الاصطناعي المشاركين في المجلس",
  "settings.councilMembers": "أعضاء المجلس",
  "settings.chairmanModel": "نموذج الرئيس",
  "settings.personasTitle": "الأخصائيون",
  "settings.personasDesc": "فعّل الأخصائيين، واختر النموذج الأساسي لكل منهم، وحدّد المجلس الافتراضي",
  "settings.personaSpecialty": "التخصص",
  "settings.personaBackingModel": "النموذج الأساسي",
  "settings.personaEnabled": "مفعّل",
  "settings.defaultCouncilMember": "في المجلس الافتراضي",
  "settings.chairmanPersona": "الرئيس",
  "settings.atLeastOneCouncilMember": "اختر أخصائيًا مفعّلًا واحدًا على الأقل للمجلس الافتراضي",
  "settings.chairmanMustBeEnabled": "يجب أن يبقى أخصائي الرئيس مفعّلًا",
  "settings.chairmanRequired": "يلزم وجود أخصائي رئيس",
  "settings.personaModelRequired": "يجب أن يكون لكل أخصائي محدد نموذج أساسي",
  "settings.councilNotConfigured": "لم يتم إعداد المجلس",
  "settings.piiRedaction": "PII Redaction",
  "settings.piiRedactionDesc": "Automatically redact sensitive data",
  "settings.saveModelSettings": "Save Model Settings",
  "settings.budgetSettings": "Budget Settings",
  "settings.budgetSettingsDesc": "Control your organization's spending",
  "settings.monthlyLimit": "Monthly Limit (USD)",
  "settings.unlimitedPlaceholder": "Leave empty for unlimited",
  "settings.alertThreshold": "Alert Threshold",
  "settings.currentSpend": "Current spend",
  "settings.saveBudgetSettings": "Save Budget Settings",
  "settings.dangerZone": "Danger Zone",
  "settings.resetMonthlySpend": "Reset Monthly Spend",
  "settings.resetDesc": "Set current month spend to $0.00",
  "settings.reset": "Reset",
  "settings.resetConfirmTitle": "Reset Monthly Spend?",
  "settings.resetConfirmDesc": "This will set the current month spend counter to $0.00. This action cannot be undone.",
  "settings.saving": "Saving...",
  "audit.filterByEmail": "Filter by email...",
  "audit.startDate": "Start",
  "audit.endDate": "End",
  "audit.export": "Export",
  "audit.timestamp": "Timestamp",
  "audit.user": "User",
  "audit.query": "Query",
  "audit.models": "Models",
  "audit.cost": "Cost",
  "audit.noLogs": "No audit logs found",
  "audit.exported": "Audit logs exported!",
  "audit.loadError": "Failed to load audit logs",
  "toast.dashboardError": "Failed to load dashboard",
  "toast.teamError": "Failed to load team",
  "toast.invitesSent": "Invitations sent!",
  "toast.inviteError": "Failed to send invites",
  "toast.roleUpdated": "Role updated",
  "toast.roleError": "Failed to update role",
  "toast.userRemoved": "User removed",
  "toast.userRemoveError": "Failed to remove user",
  "toast.modelsSaved": "Model settings saved!",
  "toast.modelsError": "Failed to save settings",
  "toast.budgetSaved": "Budget settings saved!",
  "toast.budgetError": "Failed to save settings",
  "toast.budgetReset": "Budget spend reset!",
  "toast.budgetResetError": "Failed to reset budget",
  "toast.settingsError": "Failed to load settings",
  "account.title": "Account",
  "account.profile": "Profile",
  "account.organization": "Organization",
  "account.billing": "Billing",
  "account.billingDesc": "Manage your subscription and billing",
  "account.apiKey": "API Key",
  "account.apiKeyDesc": "Use this key to access MedConcil programmatically",
  "account.regenerate": "Regenerate API Key",
  "account.regenerateConfirmTitle": "Regenerate API Key?",
  "account.regenerateConfirmDesc": "Your current API key will be invalidated immediately. Any applications using the old key will stop working.",
  "account.regenerating": "Regenerating...",
  "account.exampleUsage": "Example usage:",
  "account.upgrade": "Upgrade",
  "account.billingComingSoon": "Billing integration coming soon. Contact support to upgrade.",
  "onboarding.createOrg": "Create your organization",
  "onboarding.setupWorkspace": "Set up your workspace",
  "onboarding.configureCouncil": "Configure Consilium",
  "onboarding.selectModels": "Select AI models",
  "onboarding.setBudget": "Set spending limits",
  "onboarding.controlSpending": "Control spending",
  "onboarding.inviteTeam": "Invite your team",
  "onboarding.addCollaborators": "Add collaborators",
  "onboarding.createOrgTitle": "Create your organization",
  "onboarding.createOrgDesc": "This will be your team's workspace",
  "onboarding.orgName": "Organization Name",
  "onboarding.orgNamePlaceholder": "My Clinic",
  "onboarding.workspaceUrl": "Workspace URL",
  "onboarding.createOrgBtn": "Create Organization",
  "onboarding.creating": "Creating...",
  "onboarding.configureCouncilTitle": "Configure your Consilium",
  "onboarding.configureCouncilDesc": "Select which AI models will participate in consensus",
  "onboarding.chairmanNote": "This model synthesizes the final consensus answer",
  "onboarding.back": "Back",
  "onboarding.continue": "Continue",
  "onboarding.setBudgetTitle": "Set spending limits",
  "onboarding.setBudgetDesc": "Control your monthly AI spend",
  "onboarding.budgetNote": "Set a monthly spending cap. Leave empty for no limit.",
  "onboarding.alertNote": "Get notified when spending reaches this percentage of your budget",
  "onboarding.skip": "Skip",
  "onboarding.inviteTeamTitle": "Invite your team",
  "onboarding.inviteTeamDesc": "Add teammates to collaborate",
  "onboarding.separateEmails": "Separate multiple emails with commas",
  "onboarding.defaultRole": "Default Role",
  "onboarding.skipFinish": "Skip & Finish",
  "onboarding.completeSetup": "Complete Setup",
  "onboarding.settingUp": "Setting up...",
  "common.loading": "Loading...",
  "common.error": "Error",
  "common.success": "Success",
  "common.save": "Save",
  "common.cancel": "Cancel",
  "common.delete": "Delete",
  "common.edit": "Edit",
  "common.close": "Close",
  "common.back": "Back",
  "common.confirm": "Confirm",
  "common.authError": "Session expired. Please log in again.",
  "common.language": "اللغة",
  "common.english": "English",
  "common.spanish": "Español",
  "common.arabic": "العربية",
  "common.french": "Français",
  "common.russian": "Русский",
  "login.displayNameOptional": "الاسم (اختياري)",
  "login.signUpTitle": "التسجيل",
  "login.signUpWithEmail": "التسجيل بالبريد الإلكتروني",
  "login.signUpDesc": "Sign up to access the clinical council",
  "nav.patients": "المرضى",
  "nav.platform": "المنصة",
  "nav.newQuery": "استعلام جديد",
  "query.newQuery": "استعلام جديد",
  "query.filesOnly": "حلّل المستندات والصور المرفقة.",
  "query.confirmNewQuery": "Query is still processing. Start a new one?",
  "query.confirmNewQueryForce": "Query is still processing. Are you sure you want to start a new one?",
  "reset.invalidLink": "Invalid Link",
  "reset.tokenMissing": "Reset token is missing.",
  "reset.backToLogin": "Back to Login",
  "reset.passwordUpdated": "Password Updated",
  "reset.canSignIn": "You can now sign in with your new password.",
  "reset.signIn": "Sign In",
  "reset.newPassword": "New Password",
  "reset.enterNewPassword": "Enter a new password for your account",
  "reset.confirmPassword": "Confirm password",
  "reset.savePassword": "Save Password",
  "reset.passwordMin": "Password must be at least 6 characters",
  "reset.passwordMismatch": "Passwords do not match",
  "reset.success": "Password updated successfully",
  "reset.linkInvalid": "Link is invalid or expired",
  "reset.failed": "Password reset failed",
  "patients.title": "سجلات المرضى",
  "patients.newPatient": "مريض جديد",
  "patients.searchPlaceholder": "Search by name...",
  "patients.noPatients": "No patients",
  "patients.name": "Name",
  "patients.birthDate": "Date of birth",
  "patients.gender": "Gender",
  "patients.genderMale": "M",
  "patients.genderFemale": "F",
  "patients.actions": "Actions",
  "patients.open": "Open",
  "patients.loadError": "تعذّر تحميل السجل",
  "patients.nameRequired": "الاسم مطلوب",
  "patients.saved": "Patient saved",
  "patients.saveError": "Failed to save",
  "patients.deleted": "Patient deleted",
  "patients.deleteError": "Failed to delete",
  "patients.back": "Back",
  "patients.edit": "Edit",
  "patients.delete": "Delete",
  "patients.newPatientTitle": "New Patient",
  "patients.editPatientTitle": "Edit Patient",
  "patients.save": "Save",
  "patients.saving": "Saving...",
  "patients.personalInfo": "Personal information",
  "patients.fullName": "Full name",
  "patients.phone": "Phone",
  "patients.email": "Email",
  "patients.medicalProfile": "Medical profile",
  "patients.bloodType": "Blood type",
  "patients.allergies": "Allergies",
  "patients.diagnoses": "Chronic diagnoses",
  "patients.medications": "Current medications",
  "patients.surgeries": "Surgical history",
  "patients.familyHistory": "Family history",
  "patients.notes": "Notes",
  "patients.documents": "Documents",
  "patients.sessions": "Consilium sessions",
  "patients.upload": "Upload",
  "patients.askConsilium": "Ask Consilium",
  "patients.deleteConfirmTitle": "Delete patient?",
  "patients.deleteConfirmDesc": "This action cannot be undone.",
  "patients.cancel": "Cancel",
  "patients.notFound": "Patient not found",
  "patients.genderMaleFull": "Male",
  "patients.genderFemaleFull": "Female",
  "patients.consilium": "Consilium",
  "patients.profile": "Profile",
  "patients.contact": "Contact",
  "patients.snils": "SNILS",
  "patients.snilsPlaceholder": "123-456-789 00",
  "patients.mrn": "MRN",
  "patients.mrnPlaceholder": "12345678",
  "patients.phonePlaceholderUs": "+1 (555) 555-5555",
  "patients.phonePlaceholderCis": "+7...",
  "patients.created": "Created",
  "patients.diagnosis": "Diagnosis",
  "patients.status": "Status",
  "patients.medication": "Medication",
  "patients.dose": "Dose",
  "patients.frequency": "Frequency",
  "patients.patientDocuments": "Patient Documents",
  "patients.titleCol": "Title",
  "patients.category": "Category",
  "patients.date": "Date",
  "patients.size": "Size",
  "patients.noDocuments": "No documents",
  "patients.mode": "Mode",
  "patients.docUploaded": "Document uploaded",
  "patients.uploadError": "Upload error",
  "patients.docDeleted": "Document deleted",
  "patients.add": "Add",
  "patients.searchNamePhone": "Search by name or phone...",
  "patients.search": "Search",
  "patients.birthDateShort": "Birth Date",
  "patients.genderShort": "Sex",
  "patients.noPatientsYet": "No patients yet",
  "patients.noSessionsYet": "No sessions yet",
  "patients.deleteCardTitle": "Delete patient card?",
  "patients.cardUpdated": "Card updated",
  "patients.patientCreated": "Patient created",
  "patients.editCard": "Edit Card",
  "patients.basicInfo": "Basic Info",
  "patients.genderOther": "Other",
  "patients.noAllergies": "No allergies",
  "patients.substance": "Substance",
  "patients.severity": "Severity",
  "patients.severityMild": "Mild",
  "patients.severityModerate": "Moderate",
  "patients.severitySevere": "Severe",
  "patients.reaction": "Reaction",
  "patients.noDiagnoses": "No diagnoses",
  "patients.nameLabel": "Name",
  "patients.icd10": "ICD-10",
  "patients.noMedications": "No medications",
  "patients.noSurgeries": "No surgeries",
  "patients.hospital": "Hospital",
  "patients.familyHistoryHint": "Family history (comma-separated)",
  "patients.additionalNotes": "Additional notes",
  "patients.statusActive": "Active",
  "patients.statusRemission": "Remission",
  "patients.statusResolved": "Resolved",
  "patients.surgery": "Surgery",
  "patients.familyNotes": "Family History & Notes",
  "patients.familyExample": "Diabetes (mother)",
  "patients.additionalNotesPlaceholder": "Additional notes...",
  "onboarding.stepOrg": "Create Organization",
  "onboarding.stepCouncil": "Configure Council",
  "onboarding.stepBudget": "Set Budget",
  "onboarding.stepTeam": "Invite Team",
  "onboarding.slugPlaceholder": "my-clinic",
  "onboarding.orgCreated": "Organization created!",
  "onboarding.fillFields": "Please fill in all fields",
  "onboarding.configCouncil": "Configure your Council",
  "onboarding.configCouncilDesc": "Select AI models for consensus",
  "onboarding.councilMembers": "Council Members",
  "onboarding.chairmanModel": "Chairman Model",
  "onboarding.chairmanModelDesc": "This model synthesizes the final consensus answer",
  "onboarding.monthlyBudget": "Monthly Budget",
  "onboarding.budgetPlaceholder": "Leave empty for unlimited",
  "onboarding.budgetHint": "Set a monthly spending cap. Leave empty for no limit.",
  "onboarding.alertThreshold": "Alert Threshold",
  "onboarding.alertHint": "Get notified when spending reaches this percentage",
  "onboarding.emailAddresses": "Email Addresses",
  "onboarding.emailsHint": "Separate multiple emails with commas",
  "onboarding.roleMember": "Member",
  "onboarding.roleAdmin": "Admin",
  "onboarding.roleAuditor": "Auditor",
  "onboarding.setupComplete": "Setup complete!",
  "onboarding.startBtn": "Get Started",

  // Patient picker / confirm modals
  "patient.phonePlaceholderUs": "+1 (555) 555-5555",
  "patient.phonePlaceholderCis": "+7 916 123-45-67",
  "patient.errPhoneFormatUs": "الصيغة: +1XXXXXXXXXX",
  "patient.errPhoneFormatCis": "الصيغة: +7XXXXXXXXXX",
  "query.councilEmptyUsesDefault": "سيُختار الأطباء لحالتك.",
  "query.councilAutomatic": "سيُختار الأطباء لحالتك.",
  "query.councilGroupGeneralist": "الطب العام",
  "query.councilGroupMedical": "التخصصات الباطنية",
  "query.councilGroupSurgical": "التخصصات الجراحية",
  "query.councilGroupDiagnostic": "التشخيص",
  "query.councilSearchPlaceholder": "ابحث بالاسم أو التخصص",
  "query.councilClearAutomatic": "مسح (تلقائي)",
  "query.councilSelectedForCase": "مختارون لحالتك",
  "query.councilExpandSpecialists": "اختيار الأخصائيين",
  "query.councilCollapseSpecialists": "إخفاء الأخصائيين",
  "billing.getMoreCases": "الحصول على المزيد من الحالات",
  "billing.viewPlans": "عرض الخطط",
  "query.b2cSummary": "الملخص",
  "query.b2cNextSteps": "خطواتك التالية",
  "query.perspectiveLabel": "مستشار AI · {specialty}",
  "query.perspectiveFallback": "مستشار AI",
  "query.perspectiveMarker": "AI",
  "query.perspectiveRow": "منظورات · AI",
  "query.disclaimerRequired": "Accept the current clinical notice before submitting a case.",
  "healthProfile.units.label": "الوحدات",
  "healthProfile.units.metric": "متري",
  "healthProfile.units.imperial": "إمبراطوري",
  "healthProfile.heightFt": "الطول (قدم)",
  "healthProfile.heightIn": "الطول (بوصة)",
  "healthProfile.weightLb": "الوزن (رطل)",
  "nav.myCases": "السجل الطبي",
  "history.title": "السجل الطبي",
  "history.addRecord": "إضافة سجل",
  "history.summary": "ملخص",
  "history.timeline": "الخط الزمني",
  "history.uploadDocument": "رفع مستند",
  "history.filesSelected": "تم تحديد {count} ملفات",
  "history.tooManyFiles": "يمكن إرفاق ما يصل إلى {max} ملفات بسجل واحد.",
  "history.addEntry": "إضافة قيد",
  "history.category": "الفئة",
  "history.eventDate": "تاريخ الرعاية",
  "history.datePrecision": "دقة التاريخ",
  "history.precision.day": "يوم",
  "history.precision.month": "شهر",
  "history.precision.year": "سنة",
  "history.dateUnknown": "التاريخ غير معروف",
  "history.titleField": "العنوان",
  "history.facility": "المنشأة أو الطبيب",
  "history.notes": "ملاحظات",
  "history.details": "التفاصيل",
  "history.save": "حفظ",
  "history.cancel": "إلغاء",
  "history.delete": "حذف",
  "history.deleteConfirm": "حذف هذا السجل؟ لا يمكن التراجع.",
  "history.deleteCaseDocuments.one": "حذف أيضًا المستند المحفوظ من هذه الحالة",
  "history.deleteCaseDocuments.many": "حذف أيضًا {n} من المستندات المحفوظة من هذه الحالة",
  "history.attachedFiles.one": "{n} ملف مرفق",
  "history.attachedFiles.many": "{n} ملفات مرفقة",
  "history.dateFromCase": "التاريخ مأخوذ من الحالة. غيّره إذا كان الملف أقدم.",
  "history.fromCase": "من الحالة: {title}",
  "history.fromCaseDated": "من حالة بتاريخ {date}",
  "history.fromCaseUntitled": "من حالة",
  "history.fromCasePending": "من حالة قيد التنفيذ",
  "history.fromCaseDeleted": "من حالة محذوفة",
  "history.filePages": "{n} صفحات",
  "history.edit": "تعديل",
  "history.download": "تنزيل",
  "history.previewUnavailable": "المعاينة غير متاحة",
  "history.noRecords": "لا توجد سجلات بعد",
  "history.noOneOff": "لا توجد حالات لمرة واحدة",
  "history.aiSecondOpinion": "رأي ثانٍ بالذكاء الاصطناعي — ليس سجلًا طبيًا",
  "history.recordCount": "{count} سجلات",
  "history.storageUsage": "المستخدم {used} م.ب من {limit} م.ب",
  "history.conditions": "الحالات",
  "history.medications": "الأدوية",
  "history.allergies": "الحساسية",
  "history.noneReported": "لم يُبلَّغ عن شيء",
  "history.notProvided": "لم يُضف بعد",
  "history.review": "مراجعة",
  "history.latest": "الأحدث",
  "history.consentTitle": "تخزين السجلات الصحية",
  "history.consentAccept": "أوافق",
  "history.consentRequired": "اقبل موافقة التخزين قبل إضافة سجل.",
  "history.duplicateWarning": "يوجد ملف بالمحتوى نفسه. تم الاحتفاظ بالنسختين.",
  "history.storageFull": "تخزين السجل الطبي ممتلئ. أزل ملفًا كبيرًا ثم أعد المحاولة.",
  "history.caseFilesNotSavedTitle": "لم يتم حفظ الملفات",
  "history.caseFilesNotSaved": "لم تُحفظ هذه الملفات في السجل الطبي. أضفها لاحقًا من السجل الطبي.",
  "history.caseFilesNotSavedOk": "OK",
  "history.shareSessionExpired": "انتهت جلسة العرض. أدخل رمز الوصول مرة أخرى.",
  "history.saved": "تم حفظ السجل",
  "history.saveError": "تعذر حفظ السجل",
  "history.loadError": "تعذر تحميل السجل الطبي",
  "history.deleted": "تم حذف السجل",
  "history.saveFilesToHistory": "حفظ هذه الملفات في السجل الطبي لـ {name}",
  "history.oneOffCases": "حالات لمرة واحدة",
  "history.tierA": "العمر والجنس عند الولادة",
  "history.fileUnavailable": "الملف لم يعد متاحًا",
  "history.updated": "تم التحديث {date}",
  "history.source.user_upload": "رفعته أنت",
  "history.source.user_entered": "أدخلته أنت",
  "history.source.case_attachment": "حُفظ من حالة",
  "history.source.medconcil_case": "حالة MedConcil",
  "history.category.visit_note": "ملاحظة زيارة",
  "history.category.discharge_summary": "ملخص الخروج",
  "history.category.lab_result": "نتيجة مختبر",
  "history.category.imaging_report": "تقرير تصوير",
  "history.category.prescription": "وصفة",
  "history.category.procedure": "إجراء",
  "history.category.immunization": "تطعيم",
  "history.category.referral": "إحالة",
  "history.category.other": "أخرى",
  "history.category.ai_second_opinion": "رأي ثانٍ بالذكاء الاصطناعي",
  "history.export": "تصدير",
  "history.exportTitle": "تصدير السجل الطبي",
  "history.exportDescription": "ملخص سريري للطبيب. لا يتحقق MedConcil من هذه السجلات.",
  "history.exportFormat": "التنسيق",
  "history.format.pdf": "ملخص PDF",
  "history.format.fhir": "ملخص المريض الدولي FHIR (JSON)",
  "history.format.zip": "ZIP مع PDF وFHIR والمستندات",
  "history.includeAiOpinions": "تضمين الآراء الثانية بالذكاء الاصطناعي",
  "history.exportAiHint": "تُستبعد الآراء الثانية بالذكاء الاصطناعي ما لم يتم تحديد هذا الخيار.",
  "history.exportWholeHistory": "السجل كاملاً",
  "history.exportChooseRecords": "اختيار السجلات",
  "history.pickerTruncated": "يتم عرض أحدث {n} سجلات. السجلات الأقدم في هذه الفترة مُدرجة.",
  "history.exportIdentityTitle": "الاسم القانوني وتاريخ الميلاد",
  "history.exportIdentityHelp": "تحتاج العيادات إلى هذه البيانات في الملخص. يمكن حفظها للمرة القادمة أو استخدامها مرة واحدة. إذا تُرك الاسم فارغًا فسيظهر في المستند “Name not provided”.",
  "history.exportLegalName": "الاسم القانوني",
  "history.exportDateOfBirth": "تاريخ الميلاد",
  "history.exportSaveIdentity": "حفظ للتصدير لاحقًا",
  "history.exportUseSaved": "استخدام الاسم وتاريخ الميلاد المحفوظين",
  "history.exportChangeIdentity": "إدخال اسم أو تاريخ ميلاد مختلف",
  "history.exportDownload": "تنزيل",
  "history.exportWorking": "جارٍ إعداد التصدير…",
  "history.exportDone": "تم تنزيل التصدير",
  "history.exportError": "تعذر تصدير السجل الطبي",
  "history.exportTooLarge": "هذا التصدير كبير جدًا. أوقف إرفاق المستندات أو اختر سجلات أقل ثم أعد المحاولة.",
  "history.shareDoctorNote": "ملاحظة للطبيب",
  "history.exportIdentityInvalid": "أدخل تاريخ ميلاد حقيقيًا أو اترك الحقل فارغًا.",
  "history.share": "مشاركة",
  "history.shareTitle": "مشاركة مع طبيب",
  "history.shareDescription": "رابط لمدة محدودة. يمكنك إيقافه. النسخ التي نُزّلت تبقى لدى المستلم.",
  "history.shareExpires": "انتهاء الرابط",
  "history.shareExpires.1h": "ساعة واحدة",
  "history.shareExpires.24h": "24 ساعة",
  "history.shareExpires.7d": "7 أيام",
  "history.shareExpires.30d": "30 يومًا",
  "history.shareRequireCode": "طلب رمز من 6 أرقام",
  "history.shareNotify": "أرسل لي بريدًا عند فتح الرابط أول مرة",
  "history.shareConsentAccept": "أوافق على إرسال هذه السجلات",
  "history.shareCreate": "إنشاء الرابط",
  "history.shareWorking": "جارٍ إنشاء الرابط…",
  "history.shareCodeOnce": "انسخ الرابط والرمز الآن. لا يمكن عرضهما مرة أخرى.",
  "history.shareUrl": "الرابط",
  "history.shareCode": "رمز الدخول",
  "history.shareCopy": "نسخ الرابط",
  "history.shareCopyCode": "نسخ الرمز",
  "history.shareCodeCopied": "تم نسخ الرمز",
  "history.shareCopied": "تم نسخ الرابط",
  "history.shareDone": "تم",
  "history.shareError": "تعذر تحديث المشاركة",
  "history.shareConsentRequired": "وافق على إذن المشاركة قبل إنشاء الرابط.",
  "history.shareLimit": "لدى هذا الشخص الحد الأقصى من الروابط النشطة.",
  "history.shareWholeHistory": "السجل كاملاً",
  "history.shareChooseRecords": "اختيار السجلات",
  "history.shareIncludeSummary": "تضمين الملخص",
  "history.sharePersonFallback": "هذا الشخص",
  "history.sharesTitle": "روابط المشاركة",
  "history.noActiveShares": "لا توجد روابط نشطة",
  "history.shareStop": "إيقاف المشاركة",
  "history.shareStopped": "تم إيقاف الرابط",
  "history.shareOpens": "فُتح {count} مرات",
  "history.shareExpiresAt": "ينتهي {date}",
  "history.shareCreatedAt": "أُنشئ {date}",
  "history.shareScopeSummary": "الملخص",
  "history.shareScopeRecords": "{count} سجلات",
  "history.shareScopeAi": "يتضمن آراء الذكاء الاصطناعي",
  "history.downloadPacket": "تنزيل",
  "history.shareWithDoctor": "مشاركة مع طبيب",
  "history.packetTitle": "إعداد للطبيب",
  "history.packetDescription": "اختر ما يجب أن يراه هذا الطبيب، ثم نزّل ملفًا أو أنشئ رابطًا.",
  "history.packetStepInclude": "ما الذي يُدرج",
  "history.packetStepSend": "كيفية الإرسال",
  "history.scopeProfile": "ملخص الملف (الحساسية والأدوية والحالات ونمط الحياة)",
  "history.scopeIdentity": "الاسم القانوني وتاريخ الميلاد",
  "history.scopeDocuments": "إرفاق المستندات الأصلية",
  "history.scopeNote": "ملاحظة للطبيب",
  "history.scopeNotePlaceholder": "اختياري. حتى 1000 حرف.",
  "history.scopePeriodWhole": "الفترة: السجل كاملاً",
  "history.scopePreview": "{records} سجلات · {documents} مستندات ({size}) · {consultations} استشارات",
  "history.scopePreviewLoading": "جارٍ عد السجلات…",
  "history.packetSaveIdentity": "يُحفظ للحزم القادمة",
  "history.packetSaveRequired": "الرابط الذي يتضمن الاسم أو تاريخ الميلاد يحفظهما للحزم القادمة.",
  "history.packetIdentityOmitted": "لن يتضمن هذا الرابط الاسم أو تاريخ الميلاد.",
  "history.chooseOneItem": "اختر عنصرًا واحدًا على الأقل.",
  "history.profileAsOf": "الملف محدّث حتى {date}",
  "history.pregnancy": "الحمل",
  "history.activeProblems": "المشكلات النشطة",
  "history.vitals": "العلامات الحيوية ونمط الحياة",
  "history.height": "الطول",
  "history.weight": "الوزن",
  "history.bmi": "مؤشر كتلة الجسم",
  "history.smoking": "التدخين",
  "history.alcohol": "الكحول",
  "history.activity": "النشاط",
  "history.sleep": "النوم",
  "history.surgeries": "الإجراءات والعمليات",
  "history.scopeError.empty": "اختر عنصرًا واحدًا على الأقل.",
  "history.scopeError.outside_period": "سجل واحد أو أكثر خارج الفترة المحددة.",
  "history.scopeError.not_found": "تعذر العثور على سجل واحد أو أكثر.",
  "history.scopeError.invalid_period": "هذه الفترة غير صالحة.",
  "history.scopeError.note_too_long": "يجب ألا تتجاوز ملاحظة الطبيب 1000 حرف.",
  "history.scopeError.ambiguous_shape": "اختر السجلات بطريقة واحدة فقط.",
  "history.shareScopeProfile": "الملف",
  "history.shareScopeIdentity": "الهوية",
  "history.shareScopeDocuments": "مستندات",
  "history.shareScopeAiShort": "الذكاء الاصطناعي",
  "history.shareScopePeriod.whole": "السجل كاملاً",
  "history.shareScopePeriod.12m": "آخر 12 شهرًا",
  "history.shareScopePeriod.3y": "آخر 3 سنوات",
  "history.shareScopePeriod.5y": "آخر 5 سنوات",
  "history.shareScopePeriod.custom": "فترة مخصصة",
  "history.shareScopePeriodRange": "{label} ({from} – {to})",
  "history.period.12m": "آخر 12 شهرًا",
  "history.period.3y": "آخر 3 سنوات",
  "history.period.5y": "آخر 5 سنوات",
  "history.period.all": "السجل كاملاً",
  "history.period.custom": "مخصص",
  "history.periodChip": "{label} ({count})",
  "history.periodFrom": "من",
  "history.periodTo": "إلى",
  "history.periodUndated": "تضمين السجلات بدون تاريخ ({count})",
  "history.periodInvalid": "أدخل تاريخ بداية في أو قبل تاريخ النهاية.",
  "history.shareLog": "سجل الوصول",
  "history.shareLogEmpty": "لم يُفتح بعد",
  "history.shareEvent.unlocked": "تم الفتح",
  "history.shareEvent.file_downloaded": "تم تنزيل ملف",
  "history.shareEvent.exported": "تم التصدير",
  "history.shareClient.chrome": "Chrome",
  "history.shareClient.firefox": "Firefox",
  "history.shareClient.safari": "Safari",
  "history.shareClient.edge": "Edge",
  "history.shareClient.other": "متصفح آخر",
  "history.shareBanner": "شاركه المريض أو من يرعاه. لم تتحقق MedConcil منه. آراء الذكاء الاصطناعي موسومة وليست تشخيصًا.",
  "history.shareCodePrompt": "أدخل رمز الدخول",
  "history.shareCodeLabel": "رمز الدخول",
  "history.shareCodeContinue": "متابعة",
  "history.shareCodeOptional": "إذا لم يُعطَ لك رمز، تابع.",
  "history.shareInvalidCode": "هذا الرمز غير صحيح.",
  "history.shareLocked": "محاولات كثيرة. حاول لاحقًا.",
  "history.shareNotFound": "هذا الرابط غير متاح.",
  "history.shareDownloadPdf": "تنزيل PDF",
  "history.shareDownloadFhir": "تنزيل FHIR",
  "history.shareDownloadZip": "تنزيل ZIP",
  "history.shareLoading": "جارٍ التحميل…",
  "history.shareViewFile": "مستند",
  "history.shareCloseFile": "إغلاق",
};
